/*
 * @Description:
 * @Author: zhanjunwei
 * @Date: 2024-12-03 18:45:44
 * @LastEditors: zhanjunwei
 * @LastEditTime: 2025-01-13 16:39:39
 */
import { ServerApi } from './useServerApi';
import type { ResultTypes } from './type';
import API from './apiUrlCommon';
import { IOptions } from './api';

const noStore: RequestCache = 'no-store';

// 用户信息
export const getServerUserInfoApi = async (
  cookie: string,
  skipIntercept = false
) => {
  const payload: IOptions = {
    cookie,
    skipIntercept,
    cache: noStore,
    logger: true,
  };
  const data: ResultTypes.ResultUserInfoProps = await ServerApi.get(
    API.userinfoApi,
    payload
  );
  return data;
};

export interface IDistrict {
  value: string;
  label: string;
  children: IDistrict[];
}
// 获取省市区
export const getDistrictList = async () => {
  const { data }: { data: { list: IDistrict[] } } = await ServerApi.get(
    API.getDistrictApi,
    {
      logger: true,
    }
  );

  return data?.list;
};

// 获取团队名称;
export const getTeamName = async (
  params: { teamId: number },
  cookie: string
) => {
  const options: IOptions = { cookie, cache: noStore, logger: true };

  const data = (await ServerApi.post(API.getTeamNameApi, params, options)) as {
    teamName: string;
  };

  return data.teamName;
};

// 验证是否申领
export const getServerApplyCheckStatus = async (
  params: { productId: string; type: number },
  cookie: string
) => {
  const options: IOptions = { cookie, cache: noStore, logger: true };

  const data = await ServerApi.post(API.getApplyCheckApi, params, options);

  return data;
};
